import {RecordDAO} from "./RecordDAO";
import {AchievementManager} from "./achievement/AchievementManager";
import {settingMap} from "../data/Constants"
let instance

export class RecordManager {
  static getInstance() {
    if (!instance) {
      instance = new RecordManager()
    }
    return instance
  }

  constructor() {
    this.onAchieved = []
  }

  debug() {
    let i = 1
    setInterval(()=>{
      this.onAchieved.forEach(func => {
        func({
          title: `${i}を達成！`
        })
      })
      i++
    }, 1000)
  }

  getWeek() {
    return new Array(7).fill(null).map((_, i) => {
      const today = new Date()
      return new Date(today.getFullYear(), today.getMonth(), today.getDate() - (7 - 1 - i))
    });
  }

  getMonth() {
    return new Array(30).fill(null).map((_, i) => {
      const today = new Date()
      return new Date(today.getFullYear(), today.getMonth(), today.getDate() - (7 - 1 - i))
    });
  }

  getData(type, rangeGetter, stored) {
    const range = rangeGetter()
    const labels = range.map(d => `${d.getMonth() + 1}/${d.getDate()}`)
    const data = range.map(d => {
      const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
      return stored[type][key]
    })
    return {
      labels: labels,
      datasets: [{
        // data: [65, 59, 80, 81, 56, 55, 40],
        data,
        fill: false,
        borderColor: '#e9671f',
        tension: 0.1,
        backgroundColor: '#e9671f',
      }]
    }
  }

  addRecords(contentsType, metrics) {
    let records = RecordDAO.getInstance().readData()

    const d = new Date()

    const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    Object.keys(metrics).forEach(metricName => {
      this.appendData(records, metrics, contentsType, metricName, key)
      AchievementManager.getInstance().check(contentsType, metricName, metrics[metricName])
    })
    RecordDAO.getInstance().writeData(records)
  }

  reset() {
    RecordDAO.getInstance().reset()
  }

  appendData(records, metrics, contentsType, metricName, key) {
    if (!records[contentsType]) records[contentsType] = {}
    if (!records[contentsType][metricName]) records[contentsType][metricName] = {}

    const before = records[contentsType][metricName][key] || 0
    records[contentsType][metricName][key] = before + metrics[metricName]
  }

  loadData() {
    let records = RecordDAO.getInstance().readData()
    const time = {}
    const ret = { time }
    Object.keys(records).map(key => {
      const timeRecords = records[key]['time']
      ret[key] = records[key]['dist'] || records[key]['count'] || records[key]['continuousCount']

      if (!timeRecords) return
      Object.keys(timeRecords).forEach(date => {
        time[date] = (time[date] || 0) + timeRecords[date]
      })
    })

    // 秒→分
    Object.keys(time).forEach(date => {
      time[date] = Math.round(10*(time[date]/60))/10
    })
    ret.time = time

    return ret
  }

  getRecords() {
    const stored = this.loadData()
    const latestDate = {}
    Object.keys(stored).forEach(key => {
      const sortDates = Object.keys(stored[key]).map(str => new Date(str).getTime()).sort()
      latestDate[key] = sortDates[sortDates.length - 1]
    })
    // console.log(latestDate)
    let works = Object.keys(stored).map(key => {
      const week = this.getChartConfig(key, this.getWeek, stored)
      if (!settingMap[key]) {
        console.error(`settings for ${key} is not defined!`)
        return {}
      }
      return {
        key,
        title: settingMap[key].title,
        data: {
          week,
          month: this.getChartConfig(key, this.getMonth, stored),
        },
      }
    })
    works = works.sort((a,b) => {
      if (a.key === 'time') return -1
      if (b.key === 'time') return 1
      return latestDate[a.key] < latestDate[b.key] ? 1 : -1
    })
    return { works }
  }

  getChartConfig(type, rangeGetter, stored) {
    const data = this.getData(type, rangeGetter, stored)
    return {
      type: 'bar',
      data,
      options: {
        plugins: {
          legend: {display: false},
          subtitle: {display: false},
          title: {display: false}
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            suggestedMax: 15,
            ticks: {
              callback: (value, index, ticks) => {
                return `${value}${settingMap[type].unit}`;
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/RecordManager.js